import script from "./PropostasRepository.vue?vue&type=script&lang=js"
export * from "./PropostasRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__